module.exports = __webpack_public_path__ + "img/04_Silver_Award.544c1ca9.png";